import Menus from "../Menus";

const HelpTopicFonctionnement = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Fonctionnement de Wodzone', link: '/topics/about/fonctionnement'},
  ]
    
  const multiMenus = [
    {title: null, filter: 'HelpTopicFonctionnement'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicFonctionnement